import type { useSingleton } from "@tippyjs/react";
import { useTranslation } from "react-i18next";
import { canv } from "@/canv/global";
import { MenuIcon } from "@/icons";
import { BottomBarItem } from "@/interface/BottomBar/BottomRightBar";
import { Tooltip } from "@/interface/ui/Tooltip";

type Props = {
    singletoneTarget: ReturnType<typeof useSingleton>[1];
    isActive: boolean;
};

export const ContextMenu = ({ singletoneTarget, isActive }: Props) => {
    const { t } = useTranslation();

    const openSettingsWindow = () => {
        canv.appInterface.settingsWindow.show();
    };
    return (
        <Tooltip singleton={singletoneTarget} content={t("header.menu")}>
            <BottomBarItem
                className="barPanelSettings"
                active={isActive}
                onClick={openSettingsWindow}
            >
                <MenuIcon />
            </BottomBarItem>
        </Tooltip>
    );
};
